export default __webpack_public_path__ + "static/media/Timecamp.0206e81e.png";